import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class GlobalAlertService {
  private subject = new Subject();

  get messages(): Subject<any> {
    return this.subject;
  }

  setSuccess(message: string): void {
    this.messages.next({
      type: 'success',
      message,
    });
  }

  setError(message: string): void {
    this.messages.next({
      type: 'error',
      message,
    });
  }
}
